module.exports = __webpack_public_path__ + "img/138.4b8579c0.jpg";